export enum Category {
  ConstantLight = "ConstantLight",
  FlashLight = "FlashLight",
  Modifier = "Modifier",
  PulsedLight = "PulsedLight",
  LightModifiers = "LightModifiers",
  SoundDevices = "SoundDevices",
  Cameras = "Cameras",
  Objectives = "Objectives",
  StabilizationSystems = "StabilizationSystems",
  MemoryCards = "MemoryCards",
  DressingRoom = "DressingRoom",
  SpecialEffect = "SpecialEffect",
}

export type Equipment = {
  id: number;
  title: string;
  imageUrl: string;
  totalCount: number;
  availableCount: number;
  pricePerUnit: number;
  category: Category;
  isFixedPrice: boolean;
};

export type EquipmentResponse = {
  equipments: {
    [key in Category]: Equipment[];
  };
};

const CategoryNameMap = {
  [Category.ConstantLight]: "Постійне світло",
  [Category.PulsedLight]: "Спалахи",
  [Category.FlashLight]: "Спалахи",
  [Category.LightModifiers]: "Модифікатори світла",
  [Category.Modifier]: "Модифікатори світла",
  [Category.SoundDevices]: "Звукові прилади",
  [Category.Cameras]: "Камери",
  [Category.Objectives]: "Об'єктиви",
  [Category.StabilizationSystems]: "Стабілізатори",
  [Category.MemoryCards]: "Карти пам'яті",
  [Category.DressingRoom]: "Гримерки",
  [Category.SpecialEffect]: "Додаткове обладнання",
};

export const getCategoryName = (category: Category) => {
  return CategoryNameMap[category];
};
